// Image Data
import Img1 from './img1.png';
import Img2 from './img2.png';
import Img3 from './img3.png';
import Img4 from './img4.png';
import Img5 from './img5.png';
import Img6 from './img6.png';
import Img7 from './img7.png';
import Img8 from './img8.png';
import Img9 from './img9.png';
import Img10 from './img10.png';
import Img11 from './img11.png';
import Img12 from './img12.png';
import Img13 from './img13.png';
import Img14 from './img14.png';
import Img15 from './img15.png';
import Img16 from './img16.png';
import Img17 from './img17.png';
import Img18 from './img18.png';
import Img19 from './img19.png';
import Img20 from './img20.png';

// Thumbnail Data
import Img1_thumbnail from './img1_thumbnail.png';
import Img2_thumbnail from './img2_thumbnail.png';
import Img3_thumbnail from './img3_thumbnail.png';
import Img4_thumbnail from './img4_thumbnail.png';
import Img5_thumbnail from './img5_thumbnail.png';
import Img6_thumbnail from './img6_thumbnail.png';
import Img7_thumbnail from './img7_thumbnail.png';
import Img8_thumbnail from './img8_thumbnail.png';
import Img9_thumbnail from './img9_thumbnail.png';
import Img10_thumbnail from './img10_thumbnail.png';
import Img11_thumbnail from './img11_thumbnail.png';
import Img12_thumbnail from './img12_thumbnail.png';
import Img13_thumbnail from './img13_thumbnail.png';
import Img14_thumbnail from './img14_thumbnail.png';
import Img15_thumbnail from './img15_thumbnail.png';
import Img16_thumbnail from './img16_thumbnail.png';
import Img17_thumbnail from './img17_thumbnail.png';
import Img18_thumbnail from './img18_thumbnail.png';
import Img19_thumbnail from './img19_thumbnail.png';
import Img20_thumbnail from './img20_thumbnail.png';

export type ImageDataProps = {
  id: number;
  src: string;
  thumbnail: string;
  color: string;
  keywords: string;
  description: string;
};

const ImgData1: ImageDataProps = {
  id: 1,
  src: Img1,
  thumbnail: Img1_thumbnail,
  color: 'white',
  keywords: 'hibiscus',
  description: 'This is a picture of hibiscus.'
};

const ImgData2: ImageDataProps = {
  id: 2,
  src: Img2,
  thumbnail: Img2_thumbnail,
  color: 'white',
  keywords: 'hyotan gourd',
  description: 'This is a picture of hyottan (gourd) flowers.'
};

const ImgData3: ImageDataProps = {
  id: 3,
  src: Img3,
  thumbnail: Img3_thumbnail,
  color: 'other',
  keywords: 'hanabi fireworks',
  description: 'This is a picture of fireworks.'
};

const ImgData4: ImageDataProps = {
  id: 4,
  src: Img4,
  thumbnail: Img4_thumbnail,
  color: 'white',
  keywords: 'plum',
  description: 'This is a picture of plum.'
};

const ImgData5: ImageDataProps = {
  id: 5,
  src: Img5,
  thumbnail: Img5_thumbnail,
  color: 'blue',
  keywords: 'nemophila ',
  description: 'This is a picture of nemophila at Hitachinaka Seaside Park.'
};

const ImgData6: ImageDataProps = {
  id: 6,
  src: Img6,
  thumbnail: Img6_thumbnail,
  color: 'blue',
  keywords: 'nemophila',
  description: 'This is a picture of nemophila at Hitachinaka Seaside Park.'
};

const ImgData7: ImageDataProps = {
  id: 7,
  src: Img7,
  thumbnail: Img7_thumbnail,
  color: 'yellow',
  keywords: 'tidy tips',
  description: 'This is a picture of tidy tips at Hitachinaka Seaside Park.'
};

const ImgData8: ImageDataProps = {
  id: 8,
  src: Img8,
  thumbnail: Img8_thumbnail,
  color: 'yellow',
  keywords: 'tidy tips',
  description: 'This is a picture of tidy tips at Hitachinaka Seaside Park.'
};

const ImgData9: ImageDataProps = {
  id: 9,
  src: Img9,
  thumbnail: Img9_thumbnail,
  color: 'blue',
  keywords: 'nemophila',
  description: 'This is a picture of nemophila at Hitachinaka Seaside Park.'
};

const ImgData10: ImageDataProps = {
  id: 10,
  src: Img10,
  thumbnail: Img10_thumbnail,
  color: 'other',
  keywords: 'plum',
  description: 'This is a picture of plum.'
};

const ImgData11: ImageDataProps = {
  id: 11,
  src: Img11,
  thumbnail: Img11_thumbnail,
  color: 'yellow',
  keywords: 'rape blossom',
  description: 'This is a picture of rape blossoms.'
};

const ImgData12: ImageDataProps = {
  id: 12,
  src: Img12,
  thumbnail: Img12_thumbnail,
  color: 'yellow',
  keywords: 'tidy tips',
  description: 'This is a picture of tidy tips at Hitachinaka Seaside Park.'
};

const ImgData13: ImageDataProps = {
  id: 13,
  src: Img13,
  thumbnail: Img13_thumbnail,
  color: 'white',
  keywords: 'butterfly',
  description: 'This is a picture I took in Mt.Tsukuba.'
};

const ImgData14: ImageDataProps = {
  id: 14,
  src: Img14,
  thumbnail: Img14_thumbnail,
  color: 'white',
  keywords: 'plum',
  description: 'This is a picture of plum.'
};

const ImgData15: ImageDataProps = {
  id: 15,
  src: Img15,
  thumbnail: Img15_thumbnail,
  color: 'white',
  keywords: 'plum',
  description: 'This is a picture of plum.'
};

const ImgData16: ImageDataProps = {
  id: 16,
  src: Img16,
  thumbnail: Img16_thumbnail,
  color: 'other',
  keywords: '',
  description: 'This is a picture I took in Mt.Tsukuba.'
};

const ImgData17: ImageDataProps = {
  id: 17,
  src: Img17,
  thumbnail: Img17_thumbnail,
  color: 'yellow',
  keywords: 'tidy tips',
  description: 'This is a picture of tidy tips at Hitachinaka Seaside Park.'
};

const ImgData18: ImageDataProps = {
  id: 18,
  src: Img18,
  thumbnail: Img18_thumbnail,
  color: 'blue',
  keywords: 'nemophila',
  description: 'This is a picture of nemophila at Hitachinaka Seaside Park.'
};

const ImgData19: ImageDataProps = {
  id: 19,
  src: Img19,
  thumbnail: Img19_thumbnail,
  color: 'other',
  keywords: 'sakura cherry blossom',
  description: 'This is a picture of cherry blossom on a tennis ball.'
};

const ImgData20: ImageDataProps = {
  id: 20,
  src: Img20,
  thumbnail: Img20_thumbnail,
  color: 'white',
  keywords: 'sakura',
  description: 'This is a picture of a cherry blossom tree.'
};

export const ImageData: Array<ImageDataProps> = [
  ImgData1,
  ImgData2,
  ImgData3,
  ImgData4,
  ImgData5,
  ImgData6,
  ImgData7,
  ImgData8,
  ImgData9,
  ImgData10,
  ImgData11,
  ImgData12,
  ImgData13,
  ImgData14,
  ImgData15,
  ImgData16,
  ImgData17,
  ImgData18,
  ImgData19,
  ImgData20
];
